/**
 * weaponModMuzzles.ts — AUTO-GENERATED. Per-combo muzzle position for the
 * revolver mod combos, so a MODDED gun fires + flashes from its OWN visible
 * barrel(s) (combos have different barrel geometry — e.g. the multishot mod
 * adds a low triple-barrel cluster — so the base's fixed barrelLength can't
 * match them). [fx, fy] = muzzle point as a fraction of the 1024x576 PNG
 * (rightmost opaque column = muzzle; vertical centre of that column = bore).
 * Key = the equipped mod codes sorted + joined by '_'.
 * BETA 23.63 — regenerated for the cowboy-revolver repaint set at
 * /weapons/mods/revolver2 (white-keyed from Dylan's 2026-07-05 drop; the
 * measure script lives with the drop pipeline — rightmost alpha>=128 column).
 * Regenerate after any revolver combo art change.
 */
export const REVOLVER_MOD_MUZZLE: Record<string, [number, number]> = {
  'C': [0.8857, 0.4045],
  'C_D': [0.8916, 0.4262],
  'C_D_K': [0.8955, 0.3377],
  'C_D_K_M': [0.9619, 0.3811],
  'C_D_K_M_P': [0.9727, 0.3516],
  'C_D_K_M_P_S': [0.9727, 0.355],
  'C_D_K_M_S': [0.9727, 0.3672],
  'C_D_K_P': [0.9795, 0.3325],
  'C_D_K_P_S': [0.9688, 0.2786],
  'C_D_K_S': [0.915, 0.342],
  'C_D_M': [0.9434, 0.4453],
  'C_D_M_P': [0.9707, 0.2769],
  'C_D_M_P_S': [0.9697, 0.5503],
  'C_D_M_S': [0.9482, 0.4167],
  'C_D_P': [0.8867, 0.2743],
  'C_D_P_S': [0.9932, 0.3941],
  'C_D_S': [0.9902, 0.395],
  'C_K': [0.9141, 0.3394],
  'C_K_M': [0.9121, 0.3333],
  'C_K_M_P': [0.9697, 0.2795],
  'C_K_M_P_S': [0.9697, 0.342],
  'C_K_M_S': [0.959, 0.388],
  'C_K_P': [0.9092, 0.3411],
  'C_K_P_S': [0.958, 0.3811],
  'C_K_S': [0.8916, 0.4002],
  'C_M': [0.8535, 0.3238],
  'C_M_P': [0.8584, 0.3924],
  'C_M_P_S': [0.9717, 0.4957],
  'C_M_S': [0.8877, 0.2812],
  'C_P': [0.8848, 0.4227],
  'C_P_S': [0.8789, 0.3759],
  'C_S': [0.873, 0.4167],
  'D': [0.8867, 0.2734],
  'D_K': [0.9053, 0.3377],
  'D_K_M': [0.8779, 0.3967],
  'D_K_M_P': [0.9697, 0.2752],
  'D_K_M_P_S': [0.9727, 0.3889],
  'D_K_M_S': [0.9688, 0.329],
  'D_K_P': [0.8867, 0.276],
  'D_K_P_S': [0.9141, 0.3316],
  'D_K_S': [0.8867, 0.2778],
  'D_M': [0.9697, 0.2839],
  'D_M_P': [0.8867, 0.3655],
  'D_M_P_S': [0.9727, 0.3559],
  'D_M_S': [0.8867, 0.3689],
  'D_P': [0.8867, 0.276],
  'D_P_S': [0.8867, 0.276],
  'D_S': [0.8867, 0.2752],
  'K': [0.9141, 0.3446],
  'K_M': [0.8535, 0.322],
  'K_M_P': [0.8945, 0.3316],
  'K_M_P_S': [0.9824, 0.3655],
  'K_M_S': [0.9053, 0.3342],
  'K_P': [0.8857, 0.276],
  'K_P_S': [0.8936, 0.3394],
  'K_S': [0.8838, 0.2891],
  'M': [0.8535, 0.3229],
  'M_P': [0.8926, 0.3464],
  'M_P_S': [0.8916, 0.3724],
  'M_S': [0.8838, 0.2752],
  'P': [0.8848, 0.2752],
  'P_S': [0.8848, 0.2691],
  'S': [0.8848, 0.2847],
};
